import { render } from "./RPABot.vue?vue&type=template&id=5f1aa2b7&scoped=true"
import script from "./RPABot.vue?vue&type=script&lang=js"
export * from "./RPABot.vue?vue&type=script&lang=js"

import "./RPABot.vue?vue&type=style&index=0&id=5f1aa2b7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1aa2b7"]])

export default __exports__